import { NgClass, NgIf, NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IStepItem } from '@shared/core';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'ui-stepper-vertical',
  templateUrl: './stepper-vertical.component.html',
  styleUrls: ['./stepper-vertical.component.scss'],
  standalone: true,
  imports: [NgStyle, NgClass, NgIf, NzIconModule],
})
export class UIStepperVertical {
  @Input() onlyIcon?: boolean;
  @Input() items: IStepItem[] = [];
}
